import { useState } from "react";
import { useSelector } from "react-redux";
import { Select } from "antd";
import CustomButton from "../../common/CustomButton";

function AddAmbulanceToParkingBay({ selectedParkingBayDetails, onSubmit, errorMsg, successMsg }) {
  const allAmbulancesEmployeeMapping = useSelector((state) => state.ambulanceEmployeeMapping?.data.object || []);
  const [selectedAmbulances, setSelectedAmbulances] = useState([]);

  const handleChange = (values) => {
    setSelectedAmbulances(values);
  };

  function handleSubmit() {
    if (!selectedParkingBayDetails?.id || selectedAmbulances.length === 0) {
      console.error("🚨 Missing Parking Bay ID or no ambulances selected!");
      return;
    }

    const parkingBayId = selectedParkingBayDetails.id;
    const ambulanceIdList = selectedAmbulances;

    const query = {parkingBayId: parkingBayId, ambulanceIdList: ambulanceIdList}
    onSubmit(query);
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select Ambulances"
          value={selectedAmbulances}
          onChange={handleChange}
          options={allAmbulancesEmployeeMapping.map((ambulance) => ({
            label: ambulance.ambulanceNumber,
            value: ambulance.ambulanceId,
          }))}
        />
        {errorMsg && <span style={{ color: "red", fontSize: "14px", display: "block", marginTop: "5px" }}>{errorMsg}</span>}
        {successMsg && <span style={{ color: "green", fontSize: "14px", display: "block", marginTop: "5px" }}>{successMsg}</span>}
      </div>
      
      <div style={{ display: "flex", flexDirection: "row-reverse", margin: "1rem" }}>
        <CustomButton title="Add Mapping" onClick={handleSubmit} />
        <CustomButton title="Cancel" type="secondary" />
      </div>
    </>
  );
}

export default AddAmbulanceToParkingBay;
